import { GroupShape, Shape } from '../types';

export const calculateGroupBounds = (shapes: any[]) => {
  return shapes.reduce(
    (acc, shape) => {
      const shapeRight = shape.x + shape.width;
      const shapeBottom = shape.y + shape.height;

      acc.minX = Math.min(acc.minX, shape.x);
      acc.minY = Math.min(acc.minY, shape.y);
      acc.maxX = Math.max(acc.maxX, shapeRight);
      acc.maxY = Math.max(acc.maxY, shapeBottom);

      return acc;
    },
    {
      minX: Number.POSITIVE_INFINITY,
      minY: Number.POSITIVE_INFINITY,
      maxX: Number.NEGATIVE_INFINITY,
      maxY: Number.NEGATIVE_INFINITY
    }
  );
};

export const flattenGroup = (
  group: GroupShape | Shape,
  parentX = 0,
  parentY = 0
): any[] => {
  if (group.type !== 'group') {
    return [
      {
        ...group,
        x: parentX + group.x,
        y: parentY + group.y
      }
    ];
  }

  return group.children.flatMap((child) =>
    flattenGroup(child, parentX + group.x, parentY + group.y)
  );
};
